import { render, staticRenderFns } from "./NppvVideoGuide.vue?vue&type=template&id=1b380b0a&scoped=true"
import script from "./NppvVideoGuide.vue?vue&type=script&lang=js"
export * from "./NppvVideoGuide.vue?vue&type=script&lang=js"
import style0 from "./NppvVideoGuide.vue?vue&type=style&index=0&id=1b380b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b380b0a",
  null
  
)

export default component.exports